import moment from 'moment'
import React from 'react'
import ReactTooltip from 'react-tooltip'

const Marker = ({ id, subType, category, date, iconType, color, onClick }) => {
  return (
    <div className="marker-container" onClick={onClick} data-tip data-for={`"${id}"`} data-multiline>
      <ReactTooltip type="light" effect="solid" id={`"${id}"`}>
        Sous-type : {subType} <br />
        Catégorie : {category} <br />
        Date : {moment(date).format('DD/MM/YYYY')}
      </ReactTooltip>
      <span className={`icon-card-container icon-card icon-${iconType}`} style={{ backgroundColor: color }} />
      <span className="icon-location pin-map" style={{ color }} />
    </div>
  )
}

export default Marker
